import styled from 'styled-components';
import { ColorAddiFeedbackSuccess, ColorAddiBackgroundWhite, ColorAddiBackgroundHint, } from '@addi/foundation/dist/web/colors';
export const CheckBoxWrapper = styled.div `
  position: relative;
`;
export const CheckBoxLabel = styled.label `
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 24px;
  border-radius: 15px;
  background: ${ColorAddiBackgroundHint};
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin: 4px 3px;
    background: ${ColorAddiBackgroundWhite};
    transition: 0.3s;
  }
`;
export const CheckBox = styled.input `
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 48px;
  &:checked + ${CheckBoxLabel} {
    background: ${ColorAddiFeedbackSuccess};
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      margin-left: 29px;
      transition: 0.3s;
    }
  }
`;
//# sourceMappingURL=toggle.styled.js.map